module.exports = ".workflow-logs-viewer .select{width:auto}.log-box{min-height:500px;max-height:800px;padding:10px;margin:10px;background-color:#fff}"